import { useMemo } from 'react';
import qs from 'qs';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';

import { CalendarView } from '../../components/BookingCalendar/BookingCalendar';

interface IRouteParams {
  clubIds?: string;
  resourceIds?: string;
  tagIds?: string;
  rangeStartDate?: string;
  rangeEndDate?: string;
  calendarView?: string;
  corporation?: string;
}

export interface ICalendarSharingParams {
  corporation: string;
  calendarView: CalendarView;
  rangeStartDate: Date;
  rangeEndDate: Date;
  clubIds: string;
  tagIds: string;
  resourceIds: string;
}

export function useCalendarSharingParams(): ICalendarSharingParams {
  const location = useLocation();

  return useMemo(() => {
    const {
      clubIds,
      tagIds,
      resourceIds,
      rangeStartDate: queryStart,
      rangeEndDate: queryEnd,
      calendarView: queryView,
      corporation,
    }: IRouteParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    const calendarView: CalendarView = (queryView as CalendarView) || 'timeGridWeek';

    const dateFrom = moment(+(queryStart || ''));
    const dateTo = moment(+(queryEnd || ''));

    return {
      corporation: corporation || '',
      calendarView,
      rangeStartDate: dateFrom.toDate(),
      rangeEndDate: dateTo.toDate(),
      clubIds: clubIds || '',
      tagIds: tagIds || '',
      resourceIds: resourceIds || '',
    };
  }, [location.search]);
}
